'use client';

import React from 'react';
import { Flex } from '@osmosis/tailwind-ui/components/Box';
import { useContentSize } from '@osmosis/nextjs-components/context/ContentSizeContext';
import { cn } from '@osmosis/tailwind-ui/helpers/classes';

type Props = {
  children: React.ReactNode;
};

const getClassName = ({
  contentWidth,
  md,
  lg,
}: ReturnType<typeof useContentSize>) => {
  if (!contentWidth) {
    return 'flex-col md:mb-0 mb-4 md:flex-row';
  }

  const className = 'pt-8 flex-row';
  if (lg) {
    return `${className} [&_h1]:!text-3xl`;
  }

  if (md) {
    return `${className} [&_h1]:!text-2xl`;
  }

  return `${className} flex-col [&_h1]:!text-xl`;
};

/**
 * Client wrapper for LearnHeader's outer Flex.
 * Applies flex-direction and margins based on content container width
 * instead of viewport width.
 */
const LearnHeaderFlex = ({ children }: Props) => {
  const contentSize = useContentSize();

  const flexClassName = getClassName(contentSize);

  return (
    <Flex className={cn(` w-full justify-between pt-8`, flexClassName)}>
      {children}
    </Flex>
  );
};

export default LearnHeaderFlex;
